module.exports = __webpack_public_path__ + "img/icons BFr_18.b4116b26.png";